import { TypePolicies } from '@apollo/client'

export const typePolicies: TypePolicies = {
  PerformanceAgreement: {
    fields: {
      actionItemsInfo: {
        merge(_existing: unknown, incoming: unknown) {
          return incoming
        },
      },
    },
  },
}
